<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getQuestionsList)" class="refresh-btn">刷新</el-button>
    <div slot="content" class="detailswrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="题目名称">
            <el-input v-model="searchForm.questionsTitle" clearable placeholder="请输入问卷名称" />
          </el-form-item>
          <el-form-item label="题目类型">
            <el-select v-model="searchForm.questionsType" clearable placeholder="请选择题目类型">
              <el-option v-for="item in [{ label: '单选', value: 0 }, { label: '多选', value: 1 }, { label: '简答', value: 2 }]"
                :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getQuestionsList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getQuestionsList, { questionsTitle: null, questionsType: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addQuestions">新增题目</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteQuestionsList">批量删除</el-button>
      </div>
      <div>
        <!-- 题目列表 -->
        <el-table v-loading="loading" :data="questionsList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)">
          <el-table-column type="selection" width="50" />
          <el-table-column type="expand" width="30">
            <template slot-scope="props">
              <el-form label-position="right">
                <el-form-item label="题目名称"><span>{{ props.row.questionsTitle }}</span></el-form-item>
                <el-form-item label="题目类型"><span>{{ props.row.questionsType }}</span></el-form-item>
                <el-form-item class="option" label="题目选项" v-if="props.row.questionsType != '简答'">
                  <div v-for="(item, i) in props.row.answers" :key="item.examQuestionBankAnswerId">
                    {{ i + 1 }}. {{ item.answerContent }}
                  </div>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="questionsTitle" label="题目名称" />
          <el-table-column prop="questionsType" label="题目类型" />
          <el-table-column prop="createBy" label="创建人" />
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editQuestions(scope.row)">编辑</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="deleteQuestions(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getQuestionsList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="questionsEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="500px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules" inline>
          <el-form-item label="题目名称" prop="questionsTitle">
            <el-input v-model="editForm.questionsTitle" placeholder="请输入题目名称" />
          </el-form-item>
          <el-form-item label="题目类型" prop="questionsType">
            <el-radio-group v-model="editForm.questionsType" @change="val => setOption(val, editForm)">
              <el-radio label="单选" />
              <el-radio label="多选" />
              <el-radio label="简答" />
            </el-radio-group>
          </el-form-item>
          <el-form-item class="option" label="题目选项" prop="answers" v-if="editForm.questionsType != '简答'">
            <div class="option-wrap">
              <el-form-item v-for="(item, i) in editForm.answers" :key="i" :label="'选项' + (i + 1)"
                :prop="'answers.' + i + '.answerContent'"
                :rules="[{ required: true, message: '选项内容不能为空！', trigger: 'blur' }]">
                <el-input v-model="item.answerContent" placeholder="请输入选项内容" />
                <el-button icon="el-icon-delete" type="danger" @click="delAnswer(i)" />
              </el-form-item>
            </div>
            <el-button icon="el-icon-plus" type="primary" @click="addOption">新建选项</el-button>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增题目'" @click="addSave(editForm)">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑题目'" @click="editSave(editForm)">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script lang="js">
import { questionBankList, questionBankEdit, questionBankDelete, questionBankAdd } from "@/api/followup-questionnaire"; // 获取问卷请求
export default {
  name: "templates",
  data() {
    return {
      loading: true, // 加载中
      questionsList: [], // 题目列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      searchForm: { questionsTitle: null, questionsType: null }, // 查询表单
      multipleSelection: [], // 被选中行
      dialogVisible: false, // 新增或编辑弹框状态
      dialogTitle: null, // 弹框标题
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        questionsTitle: [{ required: true, message: "题目名称不能为空！" }],
        questionsType: [{ required: true }],
        examTemplateId: [{ required: true, message: "所属模板不能为空！" }],
        answers: [{ required: true }]
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320; // 计算表格最大高度
    this.getQuestionsList(); // 请求题目列表
  },
  methods: {
    // 请求所有题目列表
    async getQuestionsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { rows, code, total } = await questionBankList(params);
      if (code == 200) {
        rows.forEach(item => {
          switch (item.questionsType) {
            case '0': item.questionsType = '单选'; break;
            case '1': item.questionsType = '多选'; break;
            case '2': item.questionsType = '简答'; break;
          }
        });
        this.questionsList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 新增选项
    addOption() {
      this.editForm.answers.push({ answerContent: null });
    },
    // 删除选项
    delAnswer(i) {
      let list = this.editForm.answers;
      if (list.length == 1) this.$message('最后一项不能删除！');
      else list.forEach((item, index) => {
        if (index == i) list.splice(index, 1)
      })
    },
    // 切换题目类型如果不是简单添加选项
    setOption(val, obj) {
      if (val != '简答' && obj.answers.length == 0) {
        obj.answers = [{ answerContent: null }];
      }
    },
    // 新增题目
    addQuestions() {
      this.dialogVisible = true;
      this.dialogTitle = "新增题目";
      this.editForm = { questionsTitle: null, questionsType: '简答', examTemplateId: this.examTemplateId, answers: [] };
    },
    // 保存新增
    addSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          switch (obj.questionsType) {
            case '单选': obj.questionsType = '0'; break;
            case '多选': obj.questionsType = '1'; break;
            case '简答': obj.questionsType = '2'; obj.answers = []; break;
          }
          questionBankAdd(obj).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增题目成功！");
            this.dialogVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑题目信息
    editQuestions(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑题目";
      this.dialogVisible = true;
    },
    // 保存题目修改
    editSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          switch (obj.questionsType) {
            case '单选': obj.questionsType = '0'; break;
            case '多选': obj.questionsType = '1'; break;
            case '简答': obj.questionsType = '2'; obj.answers = []; break;
          }
          questionBankEdit(obj).then(res => {
            if (res.code == 200) this.$message.success("修改题目成功！");
            this.dialogVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除题目
    deleteQuestions(row) {
      this.$confirm('确认删除该题目？').then(_ => { this.del(row.examQuestionBankId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await questionBankDelete(id);
      if (code == 200) this.$message.success("删除题目成功！");
      this.$refresh(this.getQuestionsList);
    },
    // 批量删除题目
    deleteQuestionsList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何题目");
      else {
        selected.forEach(item => { selectedId.push(item.examQuestionBankId) });
        this.$confirm('确认删除该题目？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.detailswrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  /* 题目列表样式 */
  .el-table {
    border: 1px solid #e6e6e6;
    border-bottom: 0;

    .el-form {
      margin-left: 40px;

      .el-form-item {
        margin-bottom: 0;

        &.option {
          /deep/.el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;

            div {
              width: 400px;
            }
          }
        }

        /deep/.el-form-item__content {
          font-size: 12px;
          line-height: 24px;
          padding-left: 72px;


        }

        /deep/.el-form-item__label {
          color: #999;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }

  /* 题目模态框样式 */
  .questionsEdit {
    .option {
      .option-wrap {
        border: 1px solid #e6e6e6;
        padding: 0 7px;
        margin-bottom: 10px;

        .el-form-item {
          padding: 7px 0;
          margin: 0;

          &:not(:last-of-type) {
            border-bottom: 1px solid #e6e6e6;
          }

          /deep/.el-form-item__label {
            width: 60px !important;
          }

          /deep/.el-form-item__content {
            display: flex;

            .el-input {
              flex: 1;
              margin-right: 7px;
            }
          }
        }
      }
    }

    .el-form {
      .el-form-item {
        margin-right: 0;
        display: flex;

        /deep/.el-form-item__content {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
}</style>